/* KFH base: quick add, add to cart, toast, rails, sale tags, install videos.
   Loaded by snippets/kfh-assets.liquid (once per kfh- section), so guard against running twice. */
(() => {
  if (window.KFH && window.KFH.cfg) return;
  const cfg = window.KFH_CONFIG || { routes: {}, sale: {}, strings: {} };
  const t = cfg.strings;
  const desktop = window.matchMedia('(min-width: 990px)');
  // kfh-cart.js may have created window.KFH already (it adds cartDrawer); keep what's there.
  const KFH = (window.KFH = Object.assign(window.KFH || {}, { cfg }));

  /* ---------- Money: "$79" for whole amounts, "$52.25" otherwise ---------- */
  KFH.money = (cents) => {
    const whole = cents % 100 === 0;
    try {
      return new Intl.NumberFormat(cfg.locale || 'en', {
        style: 'currency', currency: cfg.currency || 'USD',
        minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2,
      }).format(cents / 100);
    } catch (e) {
      return `$${(cents / 100).toFixed(whole ? 0 : 2)}`;
    }
  };

  /* ---------- Sale tags: shown only between the sale dates ---------- */
  KFH.saleActive = () => {
    const s = cfg.sale;
    const preview = cfg.previewOk ? new URLSearchParams(window.location.search).get('kfh_preview') : null; // editor / unpublished theme only
    if (preview && s && s.enabled) return preview !== 'off';
    if (!s || !s.enabled) return false;
    const now = Date.now();
    const start = Date.parse(s.start);
    const end = Date.parse(s.end);
    return (isNaN(start) || now >= start) && (isNaN(end) || now <= end);
  };
  const syncSale = (root = document) => {
    const on = KFH.saleActive();
    root.querySelectorAll('[data-kfh-sale]').forEach((el) => { el.hidden = !on; });
    root.querySelectorAll('[data-kfh-sale-off]').forEach((el) => { el.hidden = on; });
  };

  /* ---------- Cart ---------- */
  // The cart drawer (kfh-cart-drawer) sets KFH.cartDrawer = { open(), refresh() }.
  // Until it exists, an add shows the toast instead.
  KFH.addToCart = async (items) => {
    KFH.lastOwnAdd = Date.now(); // the drawer's network watcher skips our own adds
    const res = await fetch(`${cfg.routes.cartAdd}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || t.error);
    document.dispatchEvent(new CustomEvent('kfh:cart:added', { detail: data }));
    if (KFH.cartDrawer) KFH.cartDrawer.openAfterAdd(data);
    else {
      const first = (data.items || [data])[0] || {};
      const len = KFH.lengthLabel(first.variant_title);
      KFH.toast(len ? `${t.added}: ${len}` : undefined);
    }
    return data;
  };

  // Same rule as snippets/kfh-length-label: 18" -> "18 in"; 18” | 18” | 18” (Set of 3) -> "3 × 18 in";
  // 16” | 18” | 20” -> "16 + 18 + 20 in"; 18" | 18" (Miracle Knots · 2 packs) -> "18 in · Miracle Knots · 2 packs".
  KFH.lengthLabel = (raw) => {
    const str = String(raw || '');
    const nums = str.split('|').map((p) => (p.match(/(\d+)\s*["”“]/) || [])[1]).filter(Boolean);
    if (!nums.length) return '';
    if (nums.length === 1) return `${nums[0]} in`;
    if (/pack/.test(str)) return `${nums[0]} in · ${(str.match(/\(([^)]*)\)/) || [])[1] || ''}`;
    return new Set(nums).size > 1 ? `${nums.join(' + ')} in` : `${nums.length} × ${nums[0]} in`;
  };

  /* ---------- Toast ---------- */
  let toastEl;
  let toastTimer;
  KFH.toast = (text = t.added) => {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'kfh-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.replaceChildren(document.createTextNode(`${text} · `));
    const link = document.createElement('a');
    link.href = cfg.routes.cart;
    link.textContent = t.viewCart;
    toastEl.appendChild(link);
    requestAnimationFrame(() => toastEl.classList.add('is-open'));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove('is-open'), 2600);
  };

  /* ---------- Quick add ---------- */
  const el = (tag, cls, text) => {
    const n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  };
  const icon = (d, size = 20) => {
    const s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    s.setAttribute('width', size); s.setAttribute('height', size); s.setAttribute('viewBox', '0 0 24 24');
    s.setAttribute('fill', 'none'); s.setAttribute('stroke', 'currentColor'); s.setAttribute('stroke-width', '1.5');
    s.setAttribute('stroke-linecap', 'round'); s.setAttribute('aria-hidden', 'true');
    // Ella's base.css sizes and fills every svg; inline style wins.
    s.style.cssText = `width:${size}px;height:${size}px;fill:none;stroke:currentColor;`;
    const p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    p.setAttribute('d', d); s.appendChild(p);
    return s;
  };
  const closeIcon = () => icon('M6 6l12 12M18 6L6 18');

  let active = null; // { root, trigger, onKey }

  const closeQuickAdd = () => {
    if (!active) return;
    const { root, trigger, onKey, isSheet } = active;
    document.removeEventListener('keydown', onKey);
    active = null;
    if (isSheet) {
      root.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      setTimeout(() => root.remove(), 240);
    } else {
      root.remove();
    }
    if (trigger && document.contains(trigger)) trigger.focus();
  };
  KFH.closeQuickAdd = closeQuickAdd;

  // Builds the option list, CTA and details link. Returns the container.
  const buildOptions = (data, { compact, onPriceChange }) => {
    const box = el('div');
    let chosen = data.variants.find((v) => String(v.id) === String(data.defaultId)) || null;

    const labelRow = el('div', 'kfh-qa__label-row');
    labelRow.appendChild(el('span', 'kfh-label', data.isSet ? t.setLength : t.length));
    const chosenEl = el('span', 'kfh-qa__chosen');
    labelRow.appendChild(chosenEl);
    if (!compact) box.appendChild(labelRow);

    const grid = el('div', 'kfh-chips kfh-qa__options');
    grid.setAttribute('role', 'group');
    grid.setAttribute('aria-label', data.isSet ? t.setLength : t.length);
    const cta = el('button', 'kfh-btn kfh-btn--primary kfh-btn--block kfh-qa__cta');
    cta.type = 'button';
    const err = el('p', 'kfh-qa__error');
    err.hidden = true;
    err.setAttribute('role', 'alert');

    const render = () => {
      grid.querySelectorAll('.kfh-chip').forEach((b) => b.setAttribute('aria-pressed', String(chosen && b.dataset.id === String(chosen.id))));
      chosenEl.textContent = chosen ? chosen.label : t.notChosen;
      if (chosen) {
        cta.textContent = `${t.addToCart} · ${chosen.price}`;
        cta.removeAttribute('aria-disabled');
      } else {
        cta.textContent = t.chooseLength;
        cta.setAttribute('aria-disabled', 'true');
      }
      if (onPriceChange) onPriceChange(chosen ? chosen.price : data.fromPrice);
    };

    data.variants.forEach((v) => {
      const b = el('button', 'kfh-chip');
      b.type = 'button';
      b.dataset.id = v.id;
      b.disabled = !v.available;
      b.appendChild(el('span', '', v.label));
      b.appendChild(el('span', 'kfh-chip__sub', v.available ? v.sub : t.soldOut));
      if (v.blended) b.appendChild(el('span', 'kfh-chip__tag', t.blended));
      b.addEventListener('click', () => { chosen = v; err.hidden = true; render(); });
      grid.appendChild(b);
    });

    cta.addEventListener('click', async () => {
      if (!chosen) { const first = grid.querySelector('.kfh-chip:not(:disabled)'); if (first) first.focus(); return; }
      cta.setAttribute('aria-busy', 'true');
      try {
        await KFH.addToCart([{ id: chosen.id, quantity: 1 }]);
        closeQuickAdd();
      } catch (e) {
        err.textContent = e.message || t.error;
        err.hidden = false;
      } finally {
        cta.removeAttribute('aria-busy');
      }
    });

    box.append(grid, cta, err);
    if (!compact) {
      const details = el('a', 'kfh-link kfh-qa__details', t.viewDetails);
      details.href = data.url;
      box.appendChild(details);
    }
    render();
    return box;
  };

  const openSheet = (data, trigger) => {
    const root = el('div', 'kfh kfh-sheet');
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-label', data.name);
    const scrim = el('div', 'kfh-sheet__scrim');
    scrim.addEventListener('click', closeQuickAdd);
    const panel = el('div', 'kfh-sheet__panel');
    panel.appendChild(el('div', 'kfh-sheet__grabber'));

    const head = el('div', 'kfh-sheet__head');
    if (data.image) {
      const img = el('img', 'kfh-sheet__thumb');
      img.src = data.image; img.alt = ''; img.width = 60; img.height = 80;
      head.appendChild(img);
    }
    const info = el('div', 'kfh-sheet__info');
    info.appendChild(el('div', 'kfh-sheet__name', data.name));
    const meta = [data.muse, data.spec].filter(Boolean).join(' · ');
    if (meta) info.appendChild(el('div', 'kfh-sheet__meta', meta));
    const price = el('div', 'kfh-sheet__price', data.fromPrice);
    info.appendChild(price);
    const close = el('button', 'kfh-icon-btn');
    close.type = 'button';
    close.setAttribute('aria-label', t.close);
    close.appendChild(closeIcon());
    close.addEventListener('click', closeQuickAdd);
    head.append(info, close);

    panel.append(head, buildOptions(data, { onPriceChange: (p) => { price.textContent = p; } }));
    root.append(scrim, panel);
    document.body.appendChild(root);
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(() => root.classList.add('is-open'));
    return root;
  };

  const openPopover = (data, anchor) => {
    const root = el('div', 'kfh-popover');
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-label', data.name);
    const head = el('div', 'kfh-popover__head');
    head.appendChild(el('span', 'kfh-label', data.isSet ? t.setLength : t.length));
    const close = el('button', 'kfh-icon-btn');
    close.type = 'button';
    close.setAttribute('aria-label', t.close);
    close.appendChild(closeIcon(16));
    close.addEventListener('click', closeQuickAdd);
    head.appendChild(close);
    root.append(head, buildOptions(data, { compact: true }));
    anchor.appendChild(root);
    return root;
  };

  const openQuickAdd = (trigger) => {
    const scope = trigger.closest('[data-kfh-qa-scope]');
    const script = scope && scope.querySelector('script[data-kfh-qa]');
    if (!script) return;
    let data;
    try { data = JSON.parse(script.textContent); } catch (e) { return; }

    // One-variant products skip the picker.
    if (data.variants.length === 1) {
      KFH.addToCart([{ id: data.variants[0].id, quantity: 1 }]).catch((e) => KFH.toast(e.message));
      return;
    }

    closeQuickAdd();
    const anchor = scope.querySelector('[data-kfh-qa-anchor]');
    const isSheet = !(desktop.matches && anchor);
    const root = isSheet ? openSheet(data, trigger) : openPopover(data, anchor);
    const onKey = (e) => { if (e.key === 'Escape') closeQuickAdd(); };
    document.addEventListener('keydown', onKey);
    active = { root, trigger, onKey, isSheet };
    const focusTarget = root.querySelector('.kfh-chip[aria-pressed="true"]') || root.querySelector('.kfh-chip:not(:disabled)');
    if (focusTarget) focusTarget.focus({ preventScroll: !isSheet });
  };

  /* ---------- Rails (prev / next scroll one view) ---------- */
  const scrollRail = (btn, dir) => {
    const scope = btn.closest('[data-kfh-rail-scope]');
    const rail = scope && scope.querySelector('[data-kfh-rail]');
    if (rail) rail.scrollBy({ left: dir * rail.clientWidth * 0.8, behavior: 'smooth' });
  };

  /* ---------- Install videos: tap to play / pause ---------- */
  const toggleVideo = (btn) => {
    const tile = btn.closest('.kfh-install');
    const video = tile && tile.querySelector('video');
    if (!video) return;
    if (video.paused) { video.play(); tile.classList.add('is-playing'); }
    else { video.pause(); tile.classList.remove('is-playing'); }
  };

  /* ---------- Email signup -> Klaviyo Client Subscriptions API ---------- */
  // Email only, list from theme settings. revision = Klaviyo's current stable API version.
  const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-kfh-signup]');
    if (!form) return;
    e.preventDefault();
    const k = cfg.klaviyo || {};
    const input = form.querySelector('input[type="email"]');
    const btn = form.querySelector('button[type="submit"]');
    const status = form.querySelector('.kfh-signup__status');
    const say = (msg, kind) => {
      status.textContent = msg;
      status.hidden = !msg;
      form.dataset.state = kind || '';
      input.setAttribute('aria-invalid', String(kind === 'error'));
    };
    const email = input.value.trim();
    if (!EMAIL.test(email)) { say(t.signupInvalid, 'error'); input.focus(); return; }
    const list = form.dataset.list || k.list;
    if (!k.key || !list) { say(t.signupError, 'error'); return; }
    btn.disabled = true;
    form.dataset.state = 'loading';
    btn.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(k.key)}`, {
        method: 'POST',
        headers: { revision: k.revision, 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: form.dataset.source ? `Website: ${form.dataset.source}` : 'Website',
              profile: { data: { type: 'profile', attributes: { email, properties: { signup_source: form.dataset.source || 'Website' }, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } },
            },
            relationships: { list: { data: { type: 'list', id: list } } },
          },
        }),
      });
      if (res.status === 202 || res.ok) {
        say(t.signupSuccess, 'success');
        input.value = '';
        form.dispatchEvent(new CustomEvent('kfh:subscribed', { bubbles: true }));
      } else if (res.status === 400) {
        say(t.signupInvalid, 'error');
      } else {
        say(t.signupError, 'error');
      }
    } catch (err) {
      say(t.signupError, 'error');
    } finally {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
    }
  });

  /* ---------- One delegated click handler ---------- */
  document.addEventListener('click', (e) => {
    const target = e.target.closest('[data-kfh-qa-open], [data-kfh-rail-prev], [data-kfh-rail-next], [data-kfh-video-toggle]');
    if (target) {
      if (target.matches('[data-kfh-qa-open]')) { e.preventDefault(); openQuickAdd(target); }
      else if (target.matches('[data-kfh-rail-prev]')) scrollRail(target, -1);
      else if (target.matches('[data-kfh-rail-next]')) scrollRail(target, 1);
      else if (target.matches('[data-kfh-video-toggle]')) toggleVideo(target);
      return;
    }
    // Click outside an open desktop popover closes it.
    if (active && !active.isSheet && !active.root.contains(e.target)) closeQuickAdd();
  });

  // Theme editor re-renders sections; re-apply sale visibility.
  document.addEventListener('shopify:section:load', (e) => syncSale(e.target));
  syncSale();
})();

/* ---------- Length figure (design fig()), shared by the product gallery and the bundle guide ----------
   fig: a [data-kfh-figure] element (snippets/kfh-figure). opts: { len, shape (0 straight, 1 body wave,
   2 loose wave, 3 curly), lengths: [{ n, label, available }], onPick(item), compact (dots, only the picked
   length labelled) }. */
(() => {
  // Where each length ends on the figure (viewBox 300 x 400): marks sit on the body landmark they name.
  // Figure: crown 19, neck base 86, shoulders 100, armpits 120, waist (narrowest) 215, hips (widest) 262.
  const YL = { 12: 100, 14: 113, 16: 133, 18: 156, 20: 186, 22: 213, 24: 238, 26: 262, 28: 290 };
  window.KFH = window.KFH || {};
  window.KFH.figureY = YL;
  window.KFH.drawFigure = (fig, { len, shape = 0, lengths = [], onPick, compact = false }) => {
    if (!fig || !YL[len]) return;
    const curly = shape === 3;
    // Measured stretched: body wave falls about 2 in shorter, curly about 4 in (12.5 units per inch on this figure).
    const shrink = { 1: 2, 3: 4 }[shape] || 0;
    const end = Math.max(55, YL[len] - shrink * 12.5); // never shorter than the jaw
    const N = 44;
    const TOP = 19; // crown
    // Hair hangs from the head: a dome over the crown (a little outside the head outline), then it falls behind
    // the neck and shoulders, fanning out slightly. Waves start once it clears the head.
    const half = (y) => (y < 45 ? 25 * Math.sqrt(Math.max(0, 1 - ((y - 45) / 27) ** 2)) : y < 100 ? 25 + (y - 45) * 0.07 : Math.min(34, 28.9 + (y - 100) * 0.04));
    const wave = (y) => (shape === 0 ? 0 : curly ? 4 * Math.sin(y / 5) : shape === 1 ? 7 * Math.sin((y - 50) / 5.5) : 9 * Math.sin((y - 50) / 8));
    const wob = (y) => wave(y) * Math.min(1, Math.max(0, (y - 70) / 30));
    const cx = (y) => (y < 100 ? 92 + (y - 70) * 1.2 : y < 120 ? 130 : y < 170 ? 132 - (y - 120) * 0.12 : y < 215 ? 126 - (y - 170) * 0.31 : y < 262 ? 112 + (y - 215) * 0.34 : 128 - (y - 262) * 0.09);
    const L = []; const R = [];
    for (let i = 0; i <= N; i++) {
      const y = TOP + 2 + ((end - TOP - 2) * i) / N;
      const w = half(y) + wob(y);
      L.push(`${(85 - w).toFixed(1)} ${y.toFixed(1)}`);
      R.push(`${(85 + w).toFixed(1)} ${y.toFixed(1)}`);
    }
    fig.querySelector('[data-kfh-figure-hair]').setAttribute('d', `M${L.join(' L')} Q85 ${(end + 8).toFixed(1)} ${R[N]} L${R.slice(0, N).reverse().join(' L')} Q85 ${TOP - 2} ${L[0]} Z`);
    const stretch = fig.querySelector('[data-kfh-figure-stretch]');
    stretch.setAttribute('y1', YL[len]); stretch.setAttribute('y2', YL[len]);
    stretch.style.opacity = shrink ? 1 : 0;
    const sl = fig.querySelector('[data-kfh-figure-stretch-label]');
    if (sl) { sl.hidden = !shrink; sl.style.top = `${YL[len] / 4}%`; }
    fig.querySelector('[data-kfh-figure-marks]').replaceChildren(...lengths.filter((m) => YL[m.n]).map((m) => {
      const y = YL[m.n];
      const x0 = Math.max(cx(y), 85 + half(y) + wob(y)) + 2;
      const b = document.createElement('button');
      b.type = 'button';
      b.className = `kfh-figure__mark${m.n === len ? ' is-on' : ''}${compact ? ' is-compact' : ''}`;
      b.style.top = `${y / 4}%`;
      b.style.setProperty('--x', `${x0 / 3}%`);
      b.style.setProperty('--w', `${Math.max(0, (168 - x0) / 3)}%`);
      // compact: a dot per length, only the picked one labelled (a list beside the figure has the rest).
      b.textContent = compact && m.n !== len ? '' : m.label;
      b.setAttribute('aria-label', m.label);
      b.disabled = m.available === false;
      if (onPick) b.addEventListener('click', () => onPick(m));
      return b;
    }));
  };
})();

/* Contact details in text (FAQ answers, policies, SMS terms, app text) become tap-to-call and
   tap-to-email links. Text that's already a link, or inside a form field, is left alone. */
(() => {
  const SRC = '([a-z0-9._%+-]+@kayesfabhair\\.com)|(844[\\s-]*615[\\s-]*(?:HAIR|4247)(?:\\s*\\(4247\\))?)';
  const TEST = new RegExp(SRC, 'i');
  const RE = new RegExp(SRC, 'gi');
  const linkify = (root) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: (n) => (TEST.test(n.textContent) && !n.parentElement.closest('a, button, script, style, textarea, input, select, [contenteditable]') ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT),
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      const frag = document.createDocumentFragment();
      let last = 0;
      node.textContent.replace(RE, (m, email, phone, i) => {
        frag.append(node.textContent.slice(last, i));
        const a = document.createElement('a');
        a.href = email ? `mailto:${email.toLowerCase()}` : 'tel:+18446154247';
        a.textContent = m;
        a.className = 'kfh-contact-link';
        frag.append(a);
        last = i + m.length;
        return m;
      });
      frag.append(node.textContent.slice(last));
      node.replaceWith(frag);
    });
  };
  const run = () => document.querySelectorAll('main, .shopify-policy__container').forEach(linkify);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('toggle', (e) => { if (e.target.matches && e.target.matches('details')) linkify(e.target); }, true);
})();

/* Cart page on phones: when the Checkout button is off screen (below the upsells), a slim bar shows a copy of it.
   The copy clicks the real button, so the cart form and its total stay the single source. */
(() => {
  const page = document.getElementById('KfhCartPage');
  if (!page || !('IntersectionObserver' in window)) return;
  const bar = document.createElement('div');
  bar.className = 'kfh kfh-cart__stick';
  bar.hidden = true;
  const copy = document.createElement('button');
  copy.type = 'button';
  copy.className = 'kfh-btn kfh-btn--primary';
  bar.append(copy);
  document.body.append(bar);
  let real = null;
  copy.addEventListener('click', () => { if (real) real.click(); });
  const io = new IntersectionObserver(([e]) => {
    const show = !e.isIntersecting && matchMedia('(max-width: 989px)').matches;
    if (show) copy.textContent = real.textContent.trim();
    bar.hidden = !show;
  });
  // The cart re-renders its parts after changes; keep watching whichever Checkout button is current.
  const watch = () => {
    const b = page.querySelector('[name="checkout"]');
    if (b === real) return;
    if (real) io.unobserve(real);
    real = b;
    if (real && !real.closest('[hidden]')) io.observe(real); else bar.hidden = true;
  };
  new MutationObserver(watch).observe(page, { childList: true, subtree: true });
  watch();
})();

/* Corner widgets (chat, rewards, Klaviyo teaser) step aside while a key CTA or trust row marked
   data-kfh-clear-corner is on screen, so they never cover it (kfh-base.css). Elements hidden at the
   current width never intersect, so a phone-only or desktop-only marker only counts where it shows. */
(() => {
  const els = document.querySelectorAll('[data-kfh-clear-corner]');
  if (!els.length) return;
  const seen = new Set();
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => (e.isIntersecting ? seen.add(e.target) : seen.delete(e.target)));
    document.documentElement.classList.toggle('kfh-clear-corner', seen.size > 0);
  });
  els.forEach((el) => io.observe(el));
})();

/* Track your order: a KFH-styled tracking form (page content) that opens the AfterShip tracking page
   straight on the shopper's number (kayesfab.aftership.com/<number>). Without JS it still lands on that page. */
document.addEventListener('submit', (e) => {
  const form = e.target.closest && e.target.closest('[data-kfh-track]');
  if (!form) return;
  const n = (form.querySelector('input').value || '').replace(/\s+/g, '');
  if (!n) return;
  e.preventDefault();
  window.location.href = form.action.replace(/\/?$/, '/') + encodeURIComponent(n);
});
